import { sdkRequest } from 'js-utils/http';

const COLLECTION_BASE_URL = '/api/v3/destination/collections/';

export const editCollection = (id, collectionProperties) =>
    sdkRequest(`${COLLECTION_BASE_URL}${id}/?expand.collection=image_large`, {
        method: 'POST',
        body: JSON.stringify({
            collection: collectionProperties,
        }),
    });

export const getShareUrl = (id) =>
    sdkRequest(`${COLLECTION_BASE_URL}${id}/secret-link/`, {
        method: 'POST',
        body: JSON.stringify({
            collection_id: id,
        }),
    });

export const followCollection = (id) =>
    sdkRequest(`${COLLECTION_BASE_URL}${id}/follow/`, {
        method: 'POST',
        body: JSON.stringify({}),
    });

export const unfollowCollection = (id) =>
    sdkRequest(`${COLLECTION_BASE_URL}${id}/unfollow/`, {
        method: 'POST',
        body: JSON.stringify({}),
    });
